module.exports = __webpack_public_path__ + "img/logo02.bf8125e.jpg";